import NsContent from '@britishgasenergy/react-nucleus/dist/nuc-components/NsContent';
import { COLOR_CYAN_600 } from '@connectedhomes/nucleus/build/tokens/es6/tokens';

import { NsIcon } from 'components/common/ns-icon/NsIcon';
import { FUEL_TYPES } from 'config/app-config';
import { Label } from 'components/direct-sales/quote/components/TariffTable/Label';

type FuelDetailProps = {
  children?: React.ReactNode;
  fuel?: typeof FUEL_TYPES[keyof typeof FUEL_TYPES];
  til?: object;
};

export const FuelDetail = ({ children, fuel, til }: FuelDetailProps) => {
  const iconType = fuel === FUEL_TYPES.ELECTRIC ? 'energy-solid' : 'gas-solid';

  const fuelName = fuel === FUEL_TYPES.ELECTRIC ? 'Electricity' : 'Gas';

  if (!til) {
    return null;
  }

  return (
    <NsContent spacing="compact">
      <Label text={fuelName}>
        <span style={{ color: COLOR_CYAN_600 }}>
          <NsIcon type={iconType} size="1" />
        </span>{' '}
      </Label>
      {children}
    </NsContent>
  );
};
